var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h4', {
    staticClass: "card-title mb-0"
  }, [_vm._v("Interaction"), _c('small', [_vm._v(" with " + _vm._s(_vm.name) + "  ")]), (_vm.sentimentValue >= 0) ? _c('button', {
    staticClass: "btn btn-success"
  }, [_c('span', [_vm._v(_vm._s(_vm.sentiment) + "  ")]), _c('span', {
    staticClass: "fa fa-thumbs-o-up"
  })]) : (_vm.sentimentValue == '-') ? _c('button', {
    staticClass: "btn btn-secondary"
  }, [_c('span', [_vm._v(_vm._s(_vm.sentiment) + "  ")]), _c('span')]) : _c('button', {
    staticClass: "btn btn-danger"
  }, [_c('span', [_vm._v(_vm._s(_vm.sentiment) + "  ")]), _c('span', {
    staticClass: "fa fa-thumbs-o-down"
  })])]), _c('div', {
    staticClass: "small text-muted"
  }, [_vm._v("Displaying past interactions with " + _vm._s(_vm.name))])])]), _c('br'), (_vm.loading) ? _c('div', [_vm._v("Loading Chat..."), _c('br'), _c('br')]) : _c('div', [(_vm.loadingMore) ? _c('div', {
    staticStyle: {
      "margin": "10px 0px",
      "text-align": "center"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]) : (_vm.maxChatsNotReached) ? _c('div', {
    staticStyle: {
      "margin": "10px 0px",
      "text-align": "center",
      "text-decoration": "underline",
      "color": "#0084ff",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.addNoOfChats
    }
  }, [_vm._v("View older messages...")]) : _vm._e(), (!_vm.screenFull) ? _c('app-chat', {
    attrs: {
      "msgs": _vm.chats,
      "profPic": _vm.profPicUrl,
      "botPic": _vm.avatarURL,
      "takeover": _vm.paused,
      "duplicateAgent": _vm.duplicateAgent,
      "onlineStatus": _vm.onlineStatus
    }
  }) : _vm._e()], 1), (_vm.videoIsOn) ? _c('div', {
    staticClass: "video-window",
    class: {
      fullscreen: _vm.screenFull
    }
  }, [_c('video', {
    staticClass: "friendVideoCalling",
    class: {
      fullscreen: _vm.screenFull
    },
    attrs: {
      "id": "friendsVideo",
      "autoplay": "autoplay",
      "playsinline": "playsinline"
    }
  }), _c('video', {
    staticClass: "yourVideoCalling",
    class: {
      fullscreen: _vm.screenFull
    },
    attrs: {
      "id": "yourVideo",
      "autoplay": "autoplay",
      "playsinline": "playsinline"
    }
  }), _c('br'), _c('button', {
    staticClass: "full",
    class: {
      fullscreen: _vm.screenFull
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleFullscreen
    }
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 28.361 28.361"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "version": "1.1",
      "id": "Capa_1",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 28.361 28.361",
      "xml:space": "preserve",
      "width": "14px",
      "height": "14px"
    }
  }, [_c('g', [_c('g', {
    attrs: {
      "id": "c115_arrows"
    }
  }, [_c('path', {
    attrs: {
      "d": "M28.36,19.595c0-0.868-0.665-1.57-1.491-1.57c-0.819,0.002-1.492,0.702-1.492,1.57v3.25l-6.018-6.021    c-0.582-0.583-1.524-0.583-2.106,0c-0.582,0.582-0.582,1.527,0,2.109l5.989,5.987h-3.235c-0.881,0.002-1.591,0.669-1.591,1.491    c0,0.824,0.71,1.49,1.591,1.49h6.761c0.881,0,1.59-0.665,1.593-1.49c-0.003-0.022-0.006-0.039-0.009-0.061    c0.003-0.028,0.009-0.058,0.009-0.087v-6.668H28.36z",
      "fill": "#000000"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M9,16.824l-6.015,6.021v-3.25c0-0.868-0.672-1.568-1.493-1.57c-0.824,0-1.49,0.702-1.49,1.57L0,26.264    c0,0.029,0.008,0.059,0.01,0.087c-0.002,0.021-0.006,0.038-0.008,0.061c0.002,0.825,0.712,1.49,1.592,1.49h6.762    c0.879,0,1.59-0.666,1.59-1.49c0-0.822-0.711-1.489-1.59-1.491H5.121l5.989-5.987c0.58-0.582,0.58-1.527,0-2.109    C10.527,16.241,9.584,16.241,9,16.824z",
      "fill": "#000000"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M19.359,11.535l6.018-6.017v3.25c0,0.865,0.673,1.565,1.492,1.568c0.826,0,1.491-0.703,1.491-1.568V2.097    c0-0.029-0.006-0.059-0.009-0.085c0.003-0.021,0.006-0.041,0.009-0.062c-0.003-0.826-0.712-1.491-1.592-1.491h-6.761    c-0.881,0-1.591,0.665-1.591,1.491c0,0.821,0.71,1.49,1.591,1.492h3.235l-5.989,5.987c-0.582,0.581-0.582,1.524,0,2.105    C17.835,12.12,18.777,12.12,19.359,11.535z",
      "fill": "#000000"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5.121,3.442h3.234c0.879-0.002,1.59-0.671,1.59-1.492c0-0.826-0.711-1.491-1.59-1.491H1.594    c-0.88,0-1.59,0.665-1.592,1.491C0.004,1.971,0.008,1.991,0.01,2.012C0.008,2.038,0,2.067,0,2.097l0.002,6.672    c0,0.865,0.666,1.568,1.49,1.568c0.821-0.003,1.493-0.703,1.493-1.568v-3.25L9,11.535c0.584,0.585,1.527,0.585,2.11,0    c0.58-0.581,0.58-1.524,0-2.105L5.121,3.442z",
      "fill": "#000000"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Capa_1_253_"
    }
  })])])]), _c('button', {
    staticClass: "btn btn-primary btn-lg",
    class: {
      fullscreen: _vm.screenFull
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.showFriendsFace
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-facetime-video",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("Call client")])])]) : _vm._e(), _c('form', [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "disabled": _vm.duplicateAgent
    },
    model: {
      value: (_vm.msg.content),
      callback: function($$v) {
        _vm.msg.content = $$v
      },
      expression: "msg.content"
    }
  }), _c('div', {
    staticClass: "autocomplete",
    staticStyle: {
      "position": "absolute",
      "bottom": "36px",
      "width": "100%",
      "color": "#3e515b",
      "background": "white",
      "font-size": "0.875rem"
    }
  }, _vm._l((_vm.autocompleteItems), function(item) {
    return (_vm.msg.content !== item.item.title) ? _c('div', {
      staticClass: "autocomplete-item",
      staticStyle: {
        "padding": "0 13px",
        "line-height": "2",
        "height": "2.5em"
      },
      on: {
        "click": function($event) {
          _vm.autocompleteInput(item.item.title)
        }
      }
    }, [_vm._v(_vm._s(item.item.title))]) : _vm._e()
  })), (_vm.flagged) ? _c('b-input-group-button', {
    slot: "left"
  }, [_c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      value: ("Countdown"),
      expression: "\"Countdown\"",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "btn",
    attrs: {
      "type": "button",
      "variant": _vm.countdown < 10 ? "danger" : "success",
      "disabled": "disabled"
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" " + _vm._s(_vm.countdown))])], 1) : _vm._e(), _c('b-input-group-button', {
    slot: "right"
  }, [(!_vm.videoIsOn) ? _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      value: ("Start Video Call"),
      expression: "\"Start Video Call\"",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "btn",
    attrs: {
      "type": "button",
      "variant": "secondary",
      "disabled": _vm.duplicateAgent
    },
    on: {
      "click": _vm.initializeVideocall
    }
  }, [_c('svg', {
    staticClass: "videoIcon",
    staticStyle: {
      "enable-background": "new 0 0 41.76 41.76"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "version": "1.1",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 41.76 41.76",
      "xml:space": "preserve",
      "width": "14px",
      "height": "14px"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M26.365,33.46H2.897C1.3,33.46,0,32.161,0,30.564V11.195C0,9.599,1.3,8.3,2.897,8.3h23.468   c1.597,0,2.896,1.299,2.896,2.896v19.369C29.261,32.161,27.962,33.46,26.365,33.46z M2.897,9.3C1.852,9.3,1,10.15,1,11.195v19.369   c0,1.045,0.852,1.896,1.897,1.896h23.468c1.045,0,1.896-0.85,1.896-1.896V11.195c0-1.045-0.851-1.896-1.896-1.896H2.897z",
      "fill": "#ffffff",
      "stroke": "#ffffff",
      "stroke-width": "3"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M41.26,30.73c-0.106,0-0.211-0.034-0.3-0.1l-12.499-9.354c-0.126-0.095-0.2-0.243-0.2-0.4s0.074-0.306,0.2-0.4   l12.496-9.348c0.153-0.113,0.355-0.132,0.523-0.047c0.17,0.085,0.276,0.258,0.276,0.447L41.76,30.23   c0,0.189-0.106,0.362-0.276,0.447C41.413,30.713,41.336,30.73,41.26,30.73z M29.596,20.877l11.164,8.354l-0.003-16.704   L29.596,20.877z",
      "fill": "#ffffff",
      "stroke": "#ffffff",
      "stroke-width": "3"
    }
  })])])]) : _vm._e(), (_vm.videoIsOn) ? _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      value: ("Stop Video Call"),
      expression: "\"Stop Video Call\"",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "btn",
    attrs: {
      "type": "button",
      "variant": "success",
      "disabled": _vm.duplicateAgent
    },
    on: {
      "click": _vm.initializeVideocall
    }
  }, [_c('svg', {
    staticClass: "videoIcon",
    staticStyle: {
      "enable-background": "new 0 0 41.76 41.76"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "version": "1.1",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 41.76 41.76",
      "xml:space": "preserve",
      "width": "14px",
      "height": "14px"
    }
  }, [_c('g', [_c('path', {
    attrs: {
      "d": "M26.365,33.46H2.897C1.3,33.46,0,32.161,0,30.564V11.195C0,9.599,1.3,8.3,2.897,8.3h23.468   c1.597,0,2.896,1.299,2.896,2.896v19.369C29.261,32.161,27.962,33.46,26.365,33.46z M2.897,9.3C1.852,9.3,1,10.15,1,11.195v19.369   c0,1.045,0.852,1.896,1.897,1.896h23.468c1.045,0,1.896-0.85,1.896-1.896V11.195c0-1.045-0.851-1.896-1.896-1.896H2.897z",
      "fill": "#ffffff",
      "stroke": "#ffffff",
      "stroke-width": "3"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M41.26,30.73c-0.106,0-0.211-0.034-0.3-0.1l-12.499-9.354c-0.126-0.095-0.2-0.243-0.2-0.4s0.074-0.306,0.2-0.4   l12.496-9.348c0.153-0.113,0.355-0.132,0.523-0.047c0.17,0.085,0.276,0.258,0.276,0.447L41.76,30.23   c0,0.189-0.106,0.362-0.276,0.447C41.413,30.713,41.336,30.73,41.26,30.73z M29.596,20.877l11.164,8.354l-0.003-16.704   L29.596,20.877z",
      "fill": "#ffffff",
      "stroke": "#ffffff",
      "stroke-width": "3"
    }
  })])])]) : _vm._e(), (!_vm.paused) ? _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      value: ("Pause Chatbot"),
      expression: "\"Pause Chatbot\"",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "btn",
    attrs: {
      "type": "button",
      "variant": "danger",
      "disabled": _vm.duplicateAgent
    },
    on: {
      "click": _vm.pause
    }
  }, [_c('i', {
    staticClass: "icon-control-pause"
  })]) : _vm._e(), (_vm.paused) ? _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      value: ("Unpause Chatbot"),
      expression: "\"Unpause Chatbot\"",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "btn",
    attrs: {
      "type": "button",
      "variant": "success",
      "disabled": _vm.duplicateAgent
    },
    on: {
      "click": _vm.pause
    }
  }, [_c('i', {
    staticClass: "icon-control-play"
  })]) : _vm._e(), _c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      value: (_vm.sending ? "Sending Message" : "Send Message"),
      expression: "sending ? \"Sending Message\" : \"Send Message\"",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "btn text-white",
    attrs: {
      "type": "submit",
      "variant": "secondary",
      "disabled": !_vm.msg.content || (_vm.flagged && _vm.duplicateAgent)
    },
    on: {
      "click": _vm.sendMessage
    }
  }, [(_vm.sending) ? _c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }) : _c('i', {
    staticClass: "icon-paper-plane"
  })])], 1)], 1)], 1)])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07a19137","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Interaction.vue
// module id = 901
// module chunks = 1